import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { WarningIcon } from 'partner360/components/QBR/shared/warningIcon/WarningIcon'

import { TRANSLATION_KEYS } from '../../../../../../../../translations'

import styles from './UnpopulatedData.module.scss'

interface IUnpopulatedDataProps {
  translationMessages: string[]
}

export const UnpopulatedData: FC<IUnpopulatedDataProps> = ({ translationMessages }) => {
  return (
    <div className={styles.root}>
      <WarningIcon />
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <Translation text={TRANSLATION_KEYS.unpopulatedDataBlock.title} />
        </div>
        <div className={styles.subHeader}>
          <Translation text={TRANSLATION_KEYS.unpopulatedDataBlock.pleaseCheck} />
        </div>
        <ul className={styles.warningMessages}>
          {translationMessages.map((translationMessage) => (
            <li key={translationMessage} className={styles.messageItem}>
              <Translation text={translationMessage} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
